<form class="form-container interaction-form" [formGroup]="descriptionsForm" (keydown.enter)="$event.preventDefault()">

  <ng-container *ngIf="formType === 'generalRules'">
    <ng-template #ruleTemplate>
      <div class="rules-form">
        @for (c of descriptionsForm.controls | keyvalue: sortZero; track c) {
        <div class="input-wrapper">
          <app-form-textarea class="form-input" [control]="fc(c.value)" (remove)="removeDescription(c.key)"
            [title]="'DESCRIPTIONS_FORM.RULES_TITLE' | translate" [mentionData]="mentionData">
          </app-form-textarea>
        </div>
        }
        @if (!descriptionsForm.parent) {
        <div class="add-options">
          <button type="button" class="add-description clickable"
            [appTooltip]="'DESCRIPTIONS_FORM.ADD_RULE' | translate" matTooltipShowDelay="700"
            (click)="addNewRuleField()">
            <fa-icon class="icon" [icon]="icons.plus"></fa-icon>
            {{ 'DESCRIPTIONS_FORM.RULES_TITLE' | translate }}
          </button>
        </div>
        }
      </div>
    </ng-template>
    <ng-container *ngTemplateOutlet="ruleTemplate"></ng-container>
  </ng-container>

  <ng-container *ngIf="formType === 'generalQuestions'">
    <ng-template #generalQuestionsTemplate>
      <div class="general-questions-form">
        @for (c of descriptionsForm.controls | keyvalue: sortZero; track c) {
        <div class="input-wrapper">
          <app-form-textarea class="form-input" [control]="getControl(fc(c.value).get('description'))"
            (remove)="removeDescription(c.key)" [title]="'DESCRIPTIONS_FORM.QUESTIONS_TITLE' | translate"
            [mentionData]="mentionData">
          </app-form-textarea>
          <app-form-input class="form-input" [control]="getControl(fc(c.value).get('id'))"
            [title]="'DESCRIPTIONS_FORM.QUESTIONS_ID_TITLE' | translate" [showRemoveButton]="false">
          </app-form-input>
        </div>
        }
        @if (!descriptionsForm.parent) {
        <div class="add-options">
          <button type="button" class="add-description clickable"
            [appTooltip]="'DESCRIPTIONS_FORM.ADD_QUESTION' | translate" matTooltipShowDelay="700"
            (click)="addNewQuestionField()">
            <fa-icon class="icon" [icon]="icons.plus"></fa-icon>
            {{ 'DESCRIPTIONS_FORM.QUESTIONS_TITLE' | translate }}
          </button>
        </div>
        }
      </div>
    </ng-template>
    <ng-container *ngTemplateOutlet="generalQuestionsTemplate"></ng-container>
  </ng-container>

  <ng-container *ngIf="formType === 'desired'">
    <ng-template #fieldHeader let-keyValue="key" let-sectionKey="sectionKey" let-isChild="isChild" let-isExpanded="isExpanded">
      <div class="field-header-row">
        <div class="field-header-left">
          <fa-icon class="drag-handle" cdkDragHandle [icon]="icons.grip"></fa-icon>
          <div class="field-title-text">
            {{ 'DESCRIPTIONS_FORM.FIELD' | translate }}
          </div>
        </div>
        <div class="field-header-actions">
          <fa-icon class="duplicate-icon clickable" [icon]="icons.duplicate"
            (click)="isChild ? duplicateChildField(sectionKey, keyValue) : duplicateField(keyValue); $event.stopPropagation()"></fa-icon>
          <fa-icon class="expand-icon clickable"
            [icon]="isExpanded ? icons.expand : icons.collapse"
            (click)="isChild ? toggleChildShowExtra(sectionKey, keyValue) : toggleShowExtra(keyValue); $event.stopPropagation()"
            [appTooltip]="isExpanded ? ('DESCRIPTIONS_FORM.COLLAPSE' | translate) : ('DESCRIPTIONS_FORM.EXPAND' | translate)"
            matTooltipShowDelay="700"></fa-icon>
          <fa-icon class="icon delete-icon clickable" [icon]="icons.delete"
            (click)="isChild
              ? removeDescription(keyValue, { sectionKey: sectionKey })
              : removeDescription(keyValue); $event.stopPropagation()"
            [appTooltip]="'DESCRIPTIONS_FORM.REMOVE' | translate"
            matTooltipShowDelay="700"></fa-icon>
        </div>
      </div>
    </ng-template>

    <div class="format2-form" cdkDropListGroup>
      <div #scrollContainer class="root-list" cdkDropList id="rootList" [cdkDropListEnterPredicate]="canEnterSection"
        [cdkDropListConnectedTo]="rootConnectedTo" [cdkDropListData]="descriptionsFormKeys"
        (cdkDropListDropped)="dropFormat2($event)">
        @for (key of descriptionsFormKeys; track key; let i = $index) {
        <div class="input-wrapper" cdkDrag [cdkDragData]="key" (cdkDragMoved)="onDragMoved($event, scrollContainer)">
          @if (!descriptionsForm.get(key)?.get('children')) {
          <div class="input-group" [ngClass]="{
                    expanded:
                      getControl(
                        descriptionsForm.get(key)?.get('showExtra') ?? null
                      ).value
                  }">
            <ng-container *ngTemplateOutlet="fieldHeader; context: {
                  key: key,
                  sectionKey: null,
                  isChild: false,
                  isExpanded: getControl(
                    descriptionsForm.get(key)?.get('showExtra') ?? null
                  ).value
                }">
            </ng-container>
            <app-form-input [control]="
                      getControl(
                        descriptionsForm.get(key)?.get('description') ?? null
                      )
                    " [toggleEnabled]="false" [expanded]="
                      getControl(
                        descriptionsForm.get(key)?.get('showExtra') ?? null
                      ).value
                    " [title]="'DESCRIPTIONS_FORM.DESCRIPTION_TITLE' | translate" [type]="'textarea'"
              [mentionData]="mentionData"
              [showRemoveButton]="false">
            </app-form-input>
            @if (
            getControl(
            descriptionsForm.get(key)?.get('showExtra') ?? null
            ).value
            ) {
            <div class="extra-fields">
              <app-form-input [control]="
                        getControl(descriptionsForm.get(key)?.get('id') ?? null)
                      " [title]="'DESCRIPTIONS_FORM.ID_TITLE' | translate" [showRemoveButton]="false"></app-form-input>
              <app-form-input [control]="
                        getControl(
                          descriptionsForm.get(key)?.get('format') ?? null
                        )
                      " [title]="'DESCRIPTIONS_FORM.FORMAT_TITLE' | translate"
                [showRemoveButton]="false"></app-form-input>
            </div>
            }
          </div>
          } @else {
          <div class="section-container">
            <div class="section-title">
              <fa-icon class="drag-handle" cdkDragHandle [icon]="icons.grip"></fa-icon>
              <div class="title-text">
                {{ 'DESCRIPTIONS_FORM.SECTION' | translate }}
                {{
                getControl(
                descriptionsForm.get(key)?.get('description') ?? null
                ).value
                }}
              </div>
              <div class="toggle-btn section-toggle-btn clickable" [appTooltip]="
                        isSectionExpanded(key)
                          ? ('DESCRIPTIONS_FORM.COLLAPSE' | translate)
                          : ('DESCRIPTIONS_FORM.EXPAND' | translate)
                      " (click)="toggleSection(key)">
                <fa-icon [icon]="
                          isSectionExpanded(key)
                            ? icons.expand
                            : icons.collapse
                        "></fa-icon>
              </div>
              <fa-icon class="icon edit-icon clickable" (click)="editSectionModal.open(key); $event.stopPropagation()"
                [icon]="icons.edit"></fa-icon>
              <fa-icon class="icon duplicate-icon clickable"
                (click)="duplicateSection(key); $event.stopPropagation()" [icon]="icons.duplicate"></fa-icon>
              <fa-icon class="icon delete-icon clickable"
                (click)="removeDescription(key, { shouldConfirm: true }); $event.stopPropagation()"
                [icon]="icons.delete"></fa-icon>
              @if (!isSectionExpanded(key)) {
              <span class="children-count">
                ({{ getChildrenCount(key) }})
              </span>
              }
            </div>
            @if (isSectionExpanded(key)) {
            <div class="section-content">
              <app-form-input class="id-title" [control]="
                        getControl(descriptionsForm.get(key)?.get('id') ?? null)
                      " [title]="
                        'DESCRIPTIONS_FORM.SECTION_ID_TITLE' | translate
                      " [showRemoveButton]="false"></app-form-input>
              <div #childrenContainer class="children" cdkDropList id="secList_{{ key }}" [cdkDropListEnterPredicate]="canEnterSection"
                [cdkDropListData]="childrenKeys(key)" (cdkDropListDropped)="dropFormat2($event)">
                @for (
                childKey of childrenKeys(key); track
                childKey; let j = $index) {
                <div class="input-wrapper" cdkDrag [cdkDragData]="{ key: childKey, section: key }" (cdkDragMoved)="onDragMoved($event, childrenContainer)">
                  <div class="input-group" [ngClass]="{
                            expanded: getChildShowExtra(key, childKey)
                          }">
                    <ng-container *ngTemplateOutlet="fieldHeader; context: {
                          key: childKey,
                          sectionKey: key,
                          isChild: true,
                          isExpanded: getChildShowExtra(key, childKey)
                        }">
                    </ng-container>
                    <app-form-input [control]="
                              getControl(
                                getFormGroup(
                                  descriptionsForm.get(key)?.get('children') ??
                                      null
                                )
                                  .get(childKey)
                                  ?.get('description') ?? null
                              )
                            " [toggleEnabled]="false" [expanded]="getChildShowExtra(key, childKey)"
                      [title]="'DESCRIPTIONS_FORM.DESCRIPTION_TITLE' | translate"
                      [mentionData]="mentionData"
                      [showRemoveButton]="false">
                    </app-form-input>
                    @if (getChildShowExtra(key, childKey)) {
                    <div class="extra-fields">
                      <app-form-input [control]="
                                getControl(
                                  getFormGroup(
                                    descriptionsForm.get(key)?.get('children') ??
                                      null
                                  )
                                    .get(childKey)
                                    ?.get('id') ?? null
                                )
                              " [title]="'DESCRIPTIONS_FORM.ID_TITLE' | translate"
                        [showRemoveButton]="false"></app-form-input>
                      <app-form-input [control]="
                                getControl(
                                  getFormGroup(
                                    descriptionsForm.get(key)?.get('children') ??
                                      null
                                  )
                                    .get(childKey)
                                    ?.get('format') ?? null
                                )
                              " [title]="
                                'DESCRIPTIONS_FORM.FORMAT_TITLE' | translate
                              " [showRemoveButton]="false"></app-form-input>
                    </div>
                    }
                  </div>
                </div>
                }
                <div class="add-description clickable" [appTooltip]="'DESCRIPTIONS_FORM.ADD_FIELD' | translate"
                  matTooltipShowDelay="700" (click)="addNewFormat2Field(key)">
                  <fa-icon class="icon" [icon]="icons.plus"></fa-icon>
                </div>
              </div>
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      <div class="add-options">
        @if (!descriptionsForm.parent) {
        <button type="button" class="add-description clickable" [appTooltip]="'DESCRIPTIONS_FORM.ADD_FIELD' | translate"
          [appTooltipShowDelay]="1000" [appTooltipPosition]="'top'" (click)="addNewFormat2Field()">
          <fa-icon class="icon" [icon]="icons.plus"></fa-icon>
          {{ 'DESCRIPTIONS_FORM.FIELD' | translate }}
        </button>
        }
        @if (!descriptionsForm.parent) {
        <button type="button" class="add-description clickable"
          [appTooltip]="'DESCRIPTIONS_FORM.ADD_SECTION' | translate" matTooltipShowDelay="700"
          (click)="sectionModal.open()">
          <fa-icon class="icon" [icon]="icons.plus"></fa-icon>
          {{ 'DESCRIPTIONS_FORM.SECTION' | translate }}
        </button>
        }
      </div>
    </div>
  </ng-container>

</form>

  @if (!descriptionsForm.parent && showSaveFormatOption) {
  <form class="interaction-format-form" [formGroup]="formatForm">
    <div class="options">
      <app-checkbox class="checkbox" [control]="fc(formatForm.controls['saveFormat'])">
        {{ 'DESCRIPTIONS_FORM.SAVE_MODEL' | translate }}
      </app-checkbox>
    </div>
    @if (formatForm.controls['saveFormat']?.value) {
    <div>
      <app-form-input class="format-name-input" [control]="fc(formatForm.controls['formatName'])"
        [placeholder]="'DESCRIPTIONS_FORM.INSERT_MODEL_ID' | translate">
      </app-form-input>
      @if (formatForm.controls['formatName'].hasError('pattern')) {
      <span class="pattern-error-message">
        {{ 'DESCRIPTIONS_FORM.MODEL_CANT_START_WITH_SPACE' | translate }}
      </span>
      }
    </div>
    }
  </form>
  <div class="btn-wrapper" [appTooltipDisabled]="
        descriptionsForm.valid &&
        (!formatForm.controls['saveFormat']!.value || formatForm.valid)
        " [appTooltip]="'DESCRIPTIONS_FORM.COMPLETE_ALL_FIELDS' | translate" [appTooltipShowDelay]="300">
    <app-button class="submit-button" [disabled]="
            descriptionsForm.invalid ||
            (formatForm.controls['saveFormat']!.value && formatForm.invalid)
        " (clicked)="onSubmit()" variant="primary" [text]="'DESCRIPTIONS_FORM.SAVE' | translate">
    </app-button>
  </div>
  }

<app-section-modal class="add-section-modal" [active]="sectionModal.active"
  [control]="getControl(sectionModalGroup.get('description'))" (close)="sectionModal.close()"
  (submit)="addSectionFormat2()" [title]="'DESCRIPTIONS_FORM.CREATE_SECTION' | translate">
</app-section-modal>

<app-section-modal class="edit-section-modal" [active]="editSectionModal.active"
  [control]="getControl(editSectionModalGroup.get('description'))" (close)="editSectionModal.close()"
  (submit)="editSectionName()" [title]="'DESCRIPTIONS_FORM.EDIT_SECTION' | translate">
</app-section-modal>